import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VendorsComponent } from './vendors/vendors.component';
import { CreateOrEditVendorComponent } from './vendors/create-or-edit-vendor.component';
import { PurchaseOrdersComponent } from './purchaseOrders/purchaseOrders.component';
import { CreateOrEditPurchaseOrderComponent } from './purchaseOrders/create-or-edit-purchaseOrder.component';
import { CreateOrEditPurchaseInvoiceComponent } from './purchaseInvoices/create-or-edit-purchaseInvoice.component';
import { PurchaseInvoicesComponent } from './purchaseInvoices/purchaseInvoices.component';
import { PurchaseReturnsComponent } from './purchaseReturns/purchaseReturn.component';
import { CreateOrEditPurchaseReturnComponent } from './purchaseReturns/create-or-edit-purchaseReturn.component';
import { VendorPaymentsComponent } from './vendorPayments/vendorPayments.component';
import { CreateOrEditVendorPaymentComponent } from './vendorPayments/create-or-edit-vendorPayment.component';
import { DailyPurchaseComponent } from './reports/daily-purchase/daily-purchase.component';
import { VendorPurchaseComponent } from './reports/vendor-purchase/vendor-purchase.component';
import { DepartmentPurchaseComponent } from './reports/department-purchase/department-purchase.component';
import { ItemPurchaseComponent } from './reports/item-purchase/item-purchase.component';
import { AgedPayableDetailsComponent } from './reports/aged-payable-details/aged-payable-details.component';
import { AgedPayableComponent } from './reports/aged-payable/aged-payable.component';
import { PurchaseDetailComponent } from './reports/purchase-detail/purchase-detail.component';
import { VendorStatementComponent } from './reports/vendor-statement/vendor-statement.component';

const routes: Routes = [
  {
    path: 'vendors',
    children: [
      {
        path: '',
        component: VendorsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditVendorComponent,
      }
    ]
  },
  {
    path: 'purchaseOrders',
    children: [
      {
        path: '',
        component: PurchaseOrdersComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditPurchaseOrderComponent,
      }
    ]
  },
  {
    path: 'purchaseInvoices',
    children: [
      {
        path: '',
        component: PurchaseInvoicesComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditPurchaseInvoiceComponent,
      }
    ]
  },
  {
    path: 'purchaseReturns',
    children: [
      {
        path: '',
        component: PurchaseReturnsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditPurchaseReturnComponent,
      }
    ]
    },
    {
        path: 'vendorPayments',
        children: [
            {
                path: '',
                component: VendorPaymentsComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditVendorPaymentComponent,
            }
        ]
    },
    {
      path: 'daily-purchase',
      children: [
        {
          path: '',
          component: DailyPurchaseComponent,
        }
      ]
    },
    {
      path: 'vendor-purchase',
      children: [
        {
          path: '',
          component: VendorPurchaseComponent,
        }
      ]
    },
    {
      path: 'department-purchase',
      children: [
        {
          path: '',
          component: DepartmentPurchaseComponent,
        }
      ]
    },
    {
      path: 'item-purchase',
      children: [
        {
          path: '',
          component: ItemPurchaseComponent,
        }
      ]
    },
    {
      path: 'aged-payable',
      children: [
        {
          path: '',
          component: AgedPayableComponent,
        }
      ]
    },
    {
      path: 'aged-payable-details',
      children: [
        {
          path: '',
          component: AgedPayableDetailsComponent,
        }
      ]
    },
    {
      path: 'purchase-detail',
      children: [
        {
          path: '',
          component: PurchaseDetailComponent,
        }
      ]
    },
    {
      path: 'vendor-statement',
      children: [
        {
          path: '',
          component: VendorStatementComponent,
        }
      ]
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PurchaseRoutingModule { }
